module.exports = __webpack_public_path__ + "img/1-2.b7c4ae69.jpg";